import React from 'react';
import PropTypes from 'prop-types';

const DownArrow = ({onclick= () => false}) => {
  return <span style={{marginLeft: -28, verticalAlign: 'middle'}}><svg
    height="20" onClick={onclick} width="20" viewBox="0 0 20 20"
    aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path
      d={'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.74' +
      '7c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.40' +
      '6 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0' +
      '.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z'
      }/></svg></span>;
};

DownArrow.propTypes = {
  onclick: PropTypes.func,
};

export default DownArrow;
